<div class="app-container" dir="rtl">
  <header class="app-header">
    <div class="header-title">داشبورد بر خط دیزل</div>
    <button class="back-btn" (click)="goBack()">
      <span>بازگشت</span>
      <span class="arrow">←</span>
    </button>
  </header>

  <main class="router-content p-1" style="display: flex; gap: 5px;">
    <aside class="sidebar">
      <ul class="menu-list">
        <li *ngFor="let item of menuItems" class="menu-item" style="margin-bottom: 10px;">
          <a [routerLink]="item.route" routerLinkActive="actives" class="menu-link" >
            <i class="fa {{ item.icon }}" style="margin-left: 10px; font-size: 1.1rem; width: 24px; text-align: center;"></i>
            <span>{{ item.label }}</span>
          </a>
        </li>
      </ul>
    </aside>

    <section class="content-area p-3">
      <router-outlet></router-outlet>
    </section>

  </main>
</div>
